<template>
<div
  id="app"
  :style="{ fontSize: (0.9 + 0.1 * $store.state.setting.fontSize.value) + 'em', lineHeight: (1.5 + 0.1 * $store.state.setting.vspace.value) + 'em !important', }"
  oncopy="return false;"
  class="no-select"
  :class="{ 'no-ruby': !$store.state.setting.ruby.value, 'no-annotation': !$store.state.setting.annotation.value, 'no-reference': !$store.state.setting.reference.value, 'no-subheading': !$store.state.setting.subheading.value, 'no-study': !$store.state.setting.study.value }"
  >
  <app-navbar ref="navbar" />

  <div class="container container-bible h-100" :style="styleContainerBible">
    <div class="row h-100">
      <div class="col-12 col-md-6 h-100 bible-text-wrapper">
        <app-bible-text ref="bibleText" />
      </div>
      <div class="d-none d-md-block col-md-6 h-100 bible-tool-wrapper pl-2 pr-0" style="border-left: 1px solid rgba(0, 0, 0, 0.1);">
        <app-bible-tool />
      </div>
    </div>
  </div>

  <b-modal ref="bibleModalOpen" size="sm" hide-header hide-footer centered class="modal-bible" @shown="$refs.bibleModalOpenBody.onShown()" v-model="$store.state.ui.modalBibleOpen.opened">
    <div class="bible-open-wrapper">
      <b-btn class="btn-close" variant="danger" @click="$refs.bibleModalOpen.hide()">
        <i class="far fa-times fa-fw"></i>
      </b-btn>
      <app-bible-open ref="bibleModalOpenBody" />
    </div>
  </b-modal>

  <b-modal ref="bibleModalBookOpen" size="lg" hide-header hide-footer centered class="modal-bible" @shown="$refs.bibleModalBookOpenBody.onShown()" v-model="$store.state.ui.modalBibleBookOpen.opened">
    <div class="bible-open-wrapper">
      <b-btn class="btn-close" variant="danger" @click="$refs.bibleModalBookOpen.hide()">
        <i class="far fa-times fa-fw"></i>
      </b-btn>
      <app-bible-book-open ref="bibleModalBookOpenBody" />
    </div>
  </b-modal>

  <b-modal ref="bibleModalAction" size="lg" hide-header hide-footer centered class="modal-bible" @shown="$refs.bibleModalActionBody.onShown()" @hidden="$refs.bibleModalActionBody.onHidden()" v-model="$store.state.ui.modalBibleAction.opened">
    <div class="bible-open-wrapper">
      <b-btn class="btn-close" variant="danger" @click="$refs.bibleModalAction.hide()">
        <i class="far fa-times fa-fw"></i>
      </b-btn>
      <app-bible-action ref="bibleModalActionBody" />
    </div>
  </b-modal>

  <b-modal ref="bibleModalCopy" size="md" hide-header hide-footer centered class="modal-bible" @shown="$refs.bibleModalCopyBody.onShown()" @hidden="$refs.bibleModalCopyBody.onHidden()" v-model="$store.state.ui.modalBibleCopy.opened">
    <div class="bible-open-wrapper">
      <b-btn class="btn-close" variant="danger" @click="$refs.bibleModalCopy.hide()">
        <i class="far fa-times fa-fw"></i>
      </b-btn>
      <app-bible-copy ref="bibleModalCopyBody" />
    </div>
  </b-modal>

  <b-modal ref="bibleModalTool" size="lg" hide-header hide-footer centered class="modal-bible" v-model="$store.state.ui.modalBibleTool.opened">
    <div class="bible-tool-wrapper">
      <b-btn class="btn-close" variant="danger" @click="$refs.bibleModalTool.hide()">
        <i class="far fa-times fa-fw"></i>
      </b-btn>
      <app-bible-tool ref="bibleModalToolBody" />
    </div>
  </b-modal>

  <b-modal ref="bibleModalNews" size="lg" hide-header hide-footer centered class="modal-bible" v-model="$store.state.ui.modalBibleNews.opened">
    <div class="bible-open-wrapper">
      <b-btn class="btn-close" variant="danger" @click="$refs.bibleModalNews.hide()">
        <i class="far fa-times fa-fw"></i>
      </b-btn>
      <app-bible-news ref="bibleModalNewsBody" />
    </div>
  </b-modal>

  <b-modal ref="bibleModalBuyOpen" size="md" hide-header hide-footer centered no-close-on-backdrop no-close-on-esc class="modal-bible" v-model="$store.state.ui.modalBibleBuy.opened">
    <div class="bible-open-wrapper">
      <app-bible-buy ref="bibleModalBuyBody" />
    </div>
  </b-modal>

  <b-modal ref="bibleModalAuth" size="md" hide-header hide-footer centered no-close-on-backdrop no-close-on-esc class="modal-bible" v-model="$store.state.ui.modalBibleAuth.opened">
    <div class="bible-open-wrapper">
      <app-bible-auth ref="bibleModalAuthBody" />
    </div>
  </b-modal>

  <div class="alert-wrapper position-fixed">
      <b-alert :variant="item.variant" show v-for="item in $store.state.ui.flash" v-html="item.text"></b-alert>
  </div>

  <app-ajax-loading />
</div>
</template>

<script>
import _ from 'lodash'
import AppAjaxLoading from '@/components/AppAjaxLoading.vue'
import AppBibleAction from '@/components/AppBibleAction.vue'
import AppBibleCopy from '@/components/AppBibleCopy.vue'
import AppBibleAuth from '@/components/AppBibleAuth.vue'
import AppBibleNews from '@/components/AppBibleNews.vue'
import AppBibleOpen from '@/components/AppBibleOpen.vue'
import AppBibleBookOpen from '@/components/AppBibleBookOpen.vue'
import AppBibleText from '@/components/AppBibleText.vue'
import AppBibleTool from '@/components/AppBibleTool.vue'
import AppBibleBuy from '@/components/AppBibleBuy.vue'
import AppNavbar from '@/components/AppNavbar.vue'
import { pushHistory, parseHistory, } from '@/utils/history'

export default {
  name: 'app',
  components: {
    AppAjaxLoading,
    AppBibleAction,
    AppBibleCopy,
    AppBibleAuth,
    AppBibleNews,
    AppBibleOpen,
    AppBibleBookOpen,
    AppBibleText,
    AppBibleTool,
    AppBibleBuy,
    AppNavbar,
  },
  computed: {
    styleContainerBible () {
      return {
        'height': 'calc(100vh - ' + this.$parent.navbarHeight + 'px)',
      }
    },
    auth: {
      get () { return this.$store.state.auth },
      set (value) {},
    },
    authEmail: {
      get () { return this.$store.state.auth.email },
      set (value) {},
    },
  },
  watch: {
    '$store.state.setting': {
      handler: 'onUpdateSetting',
      deep: true,
    },
    '$store.state.data.index.verse': {
      handler: 'onUpdateIndexVerse',
      deep: true,
    },
    'authEmail': {
      handler: 'onUpdateAuthEmail',
      deep: true,
    },
  },
  methods: {
    // events
    onResize: _.debounce(function(){
      this.navbarHeight = this.$refs.navbar.$el.clientHeight
    }, 300),

    onUpdateSetting () {
      this.flashBibleText()
    },

    onUpdateIndexVerse () {
      this.flashBibleText()
    },

    flashBibleText () {
      this.$refs.bibleText.$el.style.paddingRight = '0.5px'
      setTimeout(() => {
        this.$refs.bibleText.$el.style.paddingRight = '0px'
      }, 10)
    },

    onUpdateAuthEmail () {
      if (this.$store.state.auth.email) {
        this.$store.dispatch('authMe')
        this.$store.dispatch('dataBibleIndex').then(() => {
          this.onPopstate()
        })
      }
    },

    onPopstate: _.debounce(function (e) {
      const indexes = parseHistory()

      if (this.$store.state.auth.ticket === 'basic') {
        indexes.bible = 'SI'
      }

      // bible
      let bible = this.$store.state.data.info.bibles.filter((item) => { return item.code === indexes.bible })
      if (bible.length === 0) {
        bible = this.$store.state.data.info.bibles[0]
      } else {
        bible = bible[0]
      }
      indexes.bible = bible.code

      // book
      let book = bible.bible_books.filter((item) => { return item.code === indexes.book })
      if (book.length === 0) {
        book = bible.bible_books[0]
      } else {
        book = book[0]
      }
      indexes.book = book.code

      // chapter
      indexes.chapter = parseInt(indexes.chapter) || 0

      // verse
      indexes.verse = parseInt(indexes.verse) || 0

      this.$store.dispatch('dataBibleOpenWithIndex', indexes)
    }, 300),
  },

  async created () {
  },

  async mounted () {
    let params = new URLSearchParams(location.search)
    if (params.get('email') && params.get('onetimepassword')) {
      this.$store.dispatch('authVerify')
    } else {
      this.$store.dispatch('authMe')
    }
    this.$store.dispatch('uiPushFlashFromQuery')

    window.addEventListener('resize', this.onResize, false)
    window.addEventListener('popstate', this.onPopstate, false)

    this.onResize()

    setInterval(() => {
      this.$store.dispatch('uiToggleModalBibleAuth', this.$store.state.auth.email ? false : true)
      this.$store.dispatch('uiToggleModalBibleBuy', this.$store.state.auth.email && !this.$store.state.auth.ticket ? true : false)

      if (this.$store.state.data.current.bible && this.$store.state.data.current.bible.name) {
        document.title =
          this.$store.state.data.current.bible.name
          + ' '
          + this.$store.state.data.current.book.toc2
          + ' '
          + this.$store.state.data.current.chapter.code
          + ':'
          + this.$store.state.data.current.verse.code
      } else {
        document.title = this.$store.state.env.VUE_APP_NAME
      }
    }, 500)

    setInterval(() => {
      this.$store.dispatch('uiPlayFlash')
    }, 2000)

    setInterval(() => {
      if (this.$store.state.auth.email) {
        this.$store.dispatch('authMe')
      }
    }, 3 * 60 * 1000)
  },

  beforeDestroy: function () {
    window.removeEventListener('resize', this.onResize, false)
  },
}
</script>

<style lang="scss">
#app {
  height: calc(100vh - 54px);
}
</style>
